module.exports = __webpack_public_path__ + "img/icon_support_02.ab2db39e.png";